import { render, staticRenderFns } from "./my-papers.vue?vue&type=template&id=098321b9&scoped=true&"
import script from "./my-papers.vue?vue&type=script&lang=js&"
export * from "./my-papers.vue?vue&type=script&lang=js&"
import style0 from "./my-papers.vue?vue&type=style&index=0&id=098321b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098321b9",
  null
  
)

export default component.exports